/**
 * The "Only when" rows' words and the value a "+" pill starts from.
 * For Media Devoted | Created By Ciro Autiero
 */
/** What one judgement counts: the day's drops, one gateway's, or one drop. */
export type OnlyWhenScope = 'day' | 'gateway' | 'drop';

export const START = { sample: 100, settle: 45, times: 3 } as const;

const SAMPLE_HINT: Record<OnlyWhenScope, string> = {
  day: "Below this many settled SMS today (the day's total) the rule is never judged — inconclusive, never acted on. Off = any amount.",
  gateway: "Below this many settled SMS through a gateway today that gateway is never judged — inconclusive, never blocked. Off = any amount.",
  drop: 'Below this many settled SMS in a drop that drop is never judged. Off = any amount.',
};

export const HINTS = {
  visits: 'Below this many unique visits the item is never judged. Off = any amount.',
  settle: 'A drop is judged only once this many minutes have passed since it was sent — its numbers have arrived. Off = as soon as they are in.',
  shared: "The list rule's — these rules are judged on the same numbers. Changing or removing it here changes it there too.",
  times:
    "Each settled drop is judged on its own numbers — not the day added up — and only this list's (or this gateway's) drops count. In total: the action fires once this many of today's drops met the conditions, good drops in between allowed. In a row: they must come one after the other — a good drop resets the count to 0. The count starts over every morning. Off = the day's total is judged once.",
} as const;

export const sampleHint = (scope: OnlyWhenScope, visits: boolean, shared: boolean) => (shared ? HINTS.shared : visits ? HINTS.visits : SAMPLE_HINT[scope]);

const SMS_UNIT: Record<OnlyWhenScope, string> = { day: 'SMS today', gateway: 'SMS through it today', drop: 'SMS in the drop' };
const SHARED = " · the list rule's";

/** "SMS today" / "SMS through it today" / "SMS in the drop", marked when it is the list rule's. */
export const sampleUnit = (scope: OnlyWhenScope, visits: boolean, shared: boolean) => `${visits ? 'unique visits' : SMS_UNIT[scope]}${shared ? SHARED : ''}`;

export const settleUnit = (shared: boolean) => `min after it is sent${shared ? SHARED : ''}`;

/** "drops today" / "of its drops today" — the gateway counts only its own. */
export const timesUnit = (scope: OnlyWhenScope, n: number) => `${scope === 'gateway' ? 'of its ' : ''}drop${n === 1 ? '' : 's'} today`;

/** The two ways the N drops count, and what each means in a few words. */
export const TIMES_MODES = [
  { value: 'TOTAL', label: 'in total' },
  { value: 'ROW', label: 'in a row' },
] as const;
export const TIMES_NOTE = { TOTAL: 'good drops in between allowed', ROW: 'a good drop resets the count' } as const;
